module.exports = __webpack_public_path__ + "img/icon.ecbb42ce.png";